'use strict';
import React from "react";
import {Calendar, momentLocalizer, Views} from 'react-big-calendar';
import moment from 'moment-timezone';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import "react-big-calendar/lib/css/react-big-calendar.css";
import 'react-big-calendar/lib/addons/dragAndDrop/styles.scss';
import 'components/Parts/CalendarParts/css/custom-calendar.scss';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Form} from 'reactstrap';
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import {Parts, Types, Objects, Collections} from "components/index";
import API from "@beardeddevops/react.api";
import {Link} from "react-router-dom";
import {confirmAlert} from "react-confirm-alert";
import Framework from "@beardeddevops/react.framework";
import CalendarToolbar from "./CalendarToolBar";
import FormGroup from "@material-ui/core/FormGroup";
import EngineerHDCard from "../EngineerHDCard";
import Select from "react-select";
import {Call_Geocode_API} from "../../../constants/Utilities";

const DragAndDropCalendar = withDragAndDrop(Calendar);

export default class TicketCalendar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			ticket: localStorage.getItem('ticketToggled') === 'yes' ? undefined : this.props.ticket,
			events: [...this.props.events],
			resourceMap: this.props.resourceMap,
			displayDragItemInCell: true,
			currentEvent: {id: null, title: null, start: null, end: null, resourceId: null, ticket: undefined, allDay: false},
			calendarReload: false,
			show_hd_modal: false,
			onboardee: null,
			onboardees: []
		};
		this.state.events = [];
		this.state.mapsUrls = [];
		this.moveEvent = this.moveEvent.bind(this);

		this.modDate();
	}

	componentDidMount() {
		this.setState({events: this.props.events});
		//cant change the location href without reloading
		if (this.state.ticket !== undefined && localStorage.getItem('ticketToggled') === 'no') {
			let initialEvent = this.state.events.find(event => event.ticket === this.state.ticket.pkey)
			if (initialEvent !== undefined) {
				this.toggle(initialEvent)
				window.history.replaceState(null, "", "/dispatch/calendar");
			}
		}
		if (window.location.href.includes('toDate')) {
			let date = new Date(window.location.href.split('toDate/')[1]);
			date.setDate(date.getDate() + 1);
			this.handleNavigate(date)
			window.history.replaceState(null, "", "/dispatch/calendar");
		} else {
			this.setState({selectedDay: moment(this.props.defaultDate).format().split("T")[0]});
		}
		let calendar = document.getElementsByClassName('rbc-calendar')[0];
		let notCalendar = document.getElementsByClassName('table-bar')[0].clientHeight + 80;
		if (calendar) {
			calendar.style.setProperty('height', `calc(100vh - ${notCalendar}px)`)
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.events !== prevProps.events) {
			this.setState({events: [...this.props.events]});
		}
		if (this.props.mapsUrls !== null && this.props.mapsUrls !== this.state.mapsUrls) {
			this.setState({mapsUrls: this.props.mapsUrls});
		}
	}

	handleDragStart = event => {
		// console.log("handDragStart");
		this.setState({draggedEvent: event});
	}

	moveEvent = async ({event, start, end, resourceId, isAllDay: droppedOnAllDaySlot}) => {
		let {events} = this.state

		let allDay = event.allDay

		if (!event.allDay && droppedOnAllDaySlot) {
			allDay = true
		} else if (event.allDay && !droppedOnAllDaySlot) {
			allDay = false
		}

		let arrayLength = Object.keys(events).length;
		for (let i = 0; i < arrayLength; i++) {
			if (events[i].id === event.id) {
				events[i].start = start
				events[i].end = end
				events[i].resourceId = resourceId
				events[i].allDay = allDay
			}
		}
		let model = new API.BuildClass(Types.Calendar._name, API.RequestType.UPDATE);
		this.update = 'POST';
		if (start.toString().includes('00:00:00') && end.toString().includes('00:00:00')) {
			model.object.allDay = true
		}
		model.object.pkey = event.id;
		model.object.title = event.title;
		model.object.ticket = event.ticket;
		model.object.start = start;
		model.object.end = end;
		model.object.field_engineer = resourceId;
		model.object.description = event.description
		model.object.block = event.block;
		model.object.color = event.color;
		model.object.actionable = event.actionable;
		model.object.mapped = this.state.currentEvent.mapped;
		model.object.map_address = this.state.currentEvent.map_address;
		model.object.temp_fifth = this.state.currentEvent.temp_fifth;
		model.object.temp_fifth_calendar = this.state.currentEvent.temp_fifth_calendar;
		model.object.actionable_calendar = this.state.currentEvent.actionable_calendar;
		let data = null;
		try {
			data = await model.submit(null, this.update);
		} catch (error) {
		}
		this.setState({events: events})
		if (typeof this.props.resetMapsUrls === 'function') {
			this.props.resetMapsUrls();
		}
		this.props.updateData();
	}

	resizeEvent = async ({event, start, end, resourceId}) => {
		let {events} = this.state
		let arrayLength = Object.keys(events).length;
		for (let i = 0; i < arrayLength; i++) {
			if (events[i].id === event.id) {
				events[i].start = start
				events[i].end = end
			}
		}
		let model = new API.BuildClass(Types.Calendar._name, API.RequestType.UPDATE);
		this.update = 'POST';
		if (start.toString().includes('00:00:00') && end.toString().includes('00:00:00')) {
			model.object.allDay = true
		}
		model.object.pkey = event.id;
		model.object.ticket = event.ticket;
		model.object.title = event.title;
		model.object.start = start;
		model.object.end = end;
		model.object.description = event.description
		model.object.field_engineer = resourceId;
		model.object.block = event.block;
		model.object.color = event.color;
		model.object.actionable = event.actionable;
		model.object.mapped = this.state.currentEvent.mapped;
		model.object.map_address = this.state.currentEvent.map_address;
		model.object.temp_fifth = this.state.currentEvent.temp_fifth;
		model.object.temp_fifth_calendar = this.state.currentEvent.temp_fifth_calendar;
		model.object.actionable_calendar = this.state.currentEvent.actionable_calendar;
		try {
			await model.submit(null, this.update);
		} catch (error) {
		}
		this.setState({events: events})
	}

	handleSelect = async (event) => {
		let {start, end, resourceId} = event;
		if (moment(end).diff(moment(start), 'minutes') === 30) {
			end = moment(start).add(2, 'hours');
		}
		const _event = {
			start: start,
			end: end,
			resourceId: resourceId,
			ticket: null,
			allDay: event.slots.length === 1,
			color: event.slots.length === 1 ? "#2196f3" : null
		}
		this.toggle(_event)

	}

	//This function is to put the dates from PHP into valid JS dates so the calendar can read them correctly
	modDate = (events = null) => {
		//TODO: can make this faster, eventually, by making sure this is only called once. It gets called a few times
		let spreaded = events == null ? this.props.events : events;
		spreaded.forEach(e => {
			e.start = new Date(e.start);
			e.end = new Date(e.end);
		})
		this.state.events = spreaded;
	}

	toggle = (event) => {
		this.props.suspendTimeout();
		if (event.ticket === undefined || event.ticket === null || event.ticket === this.props.ticket) {
			this.setState({showModal: true, currentEvent: event});
		} else {
			this.setState({showTicketModal: true, currentEvent: event});
		}
	}

	toggleModalCalendarLog = () => {
		this.setState({
			modalCalendarLog: true
		})
	}

	toggleClose = () => {
		localStorage.setItem('ticketToggled', 'yes')
		this.props.enableTimeout();
		this.setState({
			showModal: false, onboardee: null, modalOnboarding: false, showTicketModal: false, show_hd_modal: false, hd_engineer: null, ticket: undefined
		}, () => {
			this.state.currentEvent = {id: null, title: null, start: null, end: null, resourceId: null, ticket: undefined, allDay: false}
		});
	}

	toggleCloseCalendarLog = () => {
		this.setState({
			modalCalendarLog: false
		})
	}

	

	handleSave = async () => {
		//validate google address here
		if (this.state.currentEvent.mapped && this.state.currentEvent.map_address) {
			const response = await Call_Geocode_API(this.state.currentEvent.map_address);

			if (response) {
				this.state.currentEvent.map_address = response.formatted_address;
				this.setState({currentEvent: {...this.state.currentEvent, map_address: response.formatted_address}})
			}
		}
		if (this.state.currentEvent.id) {
			let model = new API.BuildClass(Types.Calendar._name, API.RequestType.UPDATE);
			this.update = 'POST';
			model.object.allDay = this.state.currentEvent.allDay;
			if (this.state.currentEvent.start.toString().includes('00:00:00') && this.state.currentEvent.end.toString().includes('00:00:00')) {
				model.object.allDay = true
			}
			model.object.pkey = this.state.currentEvent.id;
			model.object.title = this.state.currentEvent.title;
			model.object.start = this.state.currentEvent.start;
			model.object.end = this.state.currentEvent.end;
			model.object.field_engineer = this.state.currentEvent.resourceId;
			model.object.ticket = this.state.currentEvent.ticket;
			model.object.description = this.state.currentEvent.description;
			model.object.color = this.state.currentEvent.color;
			model.object.block = this.state.currentEvent.block;
			model.object.actionable = this.state.currentEvent.actionable;
			model.object.mapped = this.state.currentEvent.mapped;
			model.object.map_address = this.state.currentEvent.map_address;
			model.object.temp_fifth = this.state.currentEvent.temp_fifth;
			model.object.temp_fifth_calendar = this.state.currentEvent.temp_fifth_calendar;
			model.object.actionable_calendar = this.state.currentEvent.actionable_calendar;
			try {
				await model.submit(null, this.update);
				this.props.updateData();
			} catch (error) {
			}
		} else {
			let model = new API.BuildClass(Types.Calendar._name, API.RequestType.CREATE);
			this.create = 'PUT';
			model.object.allDay = this.state.currentEvent.allDay;
			if (this.state.currentEvent.start.toString().includes('00:00:00') && this.state.currentEvent.end.toString().includes('00:00:00')) {
				model.object.allDay = true
			}
			model.object.title = this.state.currentEvent.title;
			model.object.start = this.state.currentEvent.start;
			model.object.end = this.state.currentEvent.end;
			model.object.field_engineer = this.state.currentEvent.resourceId;
			// A new block is not a reschedule. The ticket opened earlier stays
			// on its own appointment; drag that appointment to move it.
			model.object.ticket = null;
			model.object.description = this.state.currentEvent.description;
			model.object.color = this.state.currentEvent.color;
			model.object.block = this.state.currentEvent.block;
			model.object.actionable = this.state.currentEvent.actionable;
			model.object.mapped = this.state.currentEvent.mapped;
			model.object.map_address = this.state.currentEvent.map_address;
			model.object.temp_fifth = this.state.currentEvent.temp_fifth;
			model.object.temp_fifth_calendar = this.state.currentEvent.temp_fifth_calendar;
			model.object.actionable_calendar = this.state.currentEvent.actionable_calendar;
			try {
				await model.submit(null, this.create);
				this.props.updateData();
			} catch (error) {
			}
		}
		this.toggleClose();
	}

	handleNavigate = (date) => {
		this.setState({selectedDay: moment(date).format().split("T")[0]});
		// MainCalendar decides whether this day needs a new week of tickets.
		return this.props.handleDate(moment(date).format());
	}

	handleUpdate = async (event) => {
		let events = this.state.events
		let arrayLength = Object.keys(events).length;
		for (let i = 0; i < arrayLength; i++) {
			if (events[i].ticket == event.pkey) {
				events[i].start = event.appointment_start
				events[i].end = event.appointment_end
			}
		}

		this.setState({events: events})
		this.props.updateData();
	}

	handleCurrentEventDate = (name, date) => {
		let {currentEvent} = this.state
		currentEvent[name] = date
		this.setState({currentEvent: currentEvent})
	}

	handleDelete = async () => {

		confirmAlert({
			title: 'Confirm Delete',
			message: typeof this.delete_message !== 'undefined' ? this.delete_message : 'Are you sure you want to delete this? (NOTE: Will not delete ticket but make ticket appointment times blank)',
			buttons: [{
				label: 'Yes', onClick: async () => {
					if (this.state.currentEvent.id) {
						let model = new API.BuildClass(Types.Calendar._name, API.RequestType.DELETE);
						this.delete = 'DELETE';
						model.object.pkey = this.state.currentEvent.id;
						try {
							await model.submit(null, this.delete);
							this.props.updateData();
						} catch (error) {
						}
					}
				}
			}, {
				label: 'No', onClick: () => {
				}
			}],
			onClose: () => {
				this.toggleClose()
			}
		});


	}

	handleView = (view) => {
		this.state.currentView = view
	}

	reloadCalendar = () => {
		this.setState({calendarReload: !this.state.calendarReload})
		this.props.updateData();
	}

	eventStyleGetter = (event) => {
		const style = {
			backgroundColor: event.color ? event.color : event.users.eventColor,
		};
		return {
			style: style
		};
	}

	getHelpdesks = async (engineer) => {
		let model = new API.BuildClass(Types.Users_Help_Desk._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		model.filter = {
			'day': moment().format(), 'users': [engineer], 'shouldTrack': false
		}
		this.data = await model.submit(null, this.read);
		this.data = this.data.items;
		this.setState({
			field_engineer: this.data?.[0] ?? null, show_hd_modal: true
		});
	}

	render() {
		const today = new Date();
		const currentEvent = this.state.currentEvent
		if (currentEvent.start?.toString().includes("00:00:00") && currentEvent.end?.toString().includes("00:00:00")) {
			currentEvent.allDay = true
		}
		this.modDate();
		const formats = {
			eventTimeRangeFormat: () => {
				return "";
			}, timeGutterFormat: 'h A'
		};

		return (<div>
				<div className={"row"}>
					<div className={"col-md-12"}>
						<DragAndDropCalendar
							onNavigate={(date) => {
								this.handleNavigate(date)
							}}
							selectable
							eventPropGetter={(this.eventStyleGetter)}
							localizer={momentLocalizer(moment.tz.setDefault("America/Phoenix"))}
							events={this.props.noHoles ? [] : Object.values(this.state.events)}
							onEventDrop={(event) => {
								if (!event.event.auto_gen) this.moveEvent(event).then()
							}}
							components={{
								toolbar: props => (
									<CalendarToolbar {...props} handleView={(view) => this.handleView(view)} noHoles={this.props.noHoles}/>),
								event: Parts.Event,
								resourceHeader: (obj) => {
									let homeAddress = (obj.resource.street_1 + "+" + obj.resource.city + "+" + obj.resource.state + "+" + obj.resource.zip).replaceAll("#", "%23")
									homeAddress = homeAddress === "+++" ? "" : homeAddress
									let currentFe = this.state.mapsUrls.find((url) => url.pkey === obj.resource.resourceId)
									let href = currentFe !== undefined ? currentFe.mapsUrls[this.state.selectedDay] === undefined ? "https://www.google.com/maps/dir/" + homeAddress : currentFe.mapsUrls[this.state.selectedDay] : "https://www.google.com/maps/dir/" + homeAddress;
									return (<div style={{display: 'flex', flexDirection: 'column'}}>
										{this.state.currentView !== 'week' ?
											<a title={obj.resource.active ? "Launch Daily Map" : "Launch Daily Map **INACTIVE**"}
											   href={href}
											   target={"_blank"} style={{
												fontWeight: 'bold', textDecoration: obj.resource.active ? 'none' : 'line-through'
											}}>{obj.label}</a> : <a title={obj.resource.active ? "" : "**INACTIVE**"} style={{
												fontWeight: 'bold', textDecoration: obj.resource.active ? 'none' : 'line-through'
											}}>{obj.label}</a>}
										{this.state.currentView !== 'week' && <>
											<div>
												{moment().format('YYYY-MM-DD') === this.state.selectedDay &&
													<b style={{color: 'green', cursor: 'pointer'}}
													   title="Show full day"
													   onClick={async () => {
														   //pop hd modal here
														   await this.getHelpdesks(obj.resource.resourceId)
													   }}>{obj.resource.last_status}</b>}

											</div>
											<div>
												<sup title="Total Drive Time">
													{!this.props.loadingResources ?
														<>
															{obj.resource.routeTime ? (obj.resource.routeTime + " min route") : "\xa0"}
														</>
														:
														<>
															Loading
														</>
													}
												</sup>
											</div>
										</>}
									</div>)
								}
							}}
							resizable
							// onView={(view)=>this.handleView(view)}
							style={{height: "800px", width: '100%'}}
							onEventResize={(event) => {
								if (!event.event.auto_gen) this.resizeEvent(event).then()
							}}
							tooltipAccessor={'customTooltip'}
							onDragStart={console.log}
							onView={this.props.handleUpdateView}
							defaultView={this.props.defaultView}
							defaultDate={this.props.defaultDate}
							popup={true}
							dragFromOutsideItem={this.state.displayDragItemInCell ? this.dragFromOutsideItem : null}
							onDropFromOutside={this.onDropFromOutside}
							handleDragStart={(event) => {
								if (!event.event.auto_gen) this.handleDragStart(event)
							}}
							onSelectEvent={event => {
								if (!event.auto_gen) this.toggle(event)
							}}
							onSelectSlot={(event) => {
								if (!event.auto_gen) this.handleSelect(event).then()
							}}
							resources={this.props.noHoles ? [] : this.props.resourceMap}
							resourceIdAccessor="resourceId"
							resourceTitleAccessor="resourceTitle"
							formats={formats}
							//dayLayoutAlgorithm={'no-overlap'}
							// start time 5:00am
							min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 5)}
							// end time 10:00pm
							max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 22)}
						/>
					</div>
					{/*This can wait until after the MVP*/}
					{/*{this.state.unassignedEvents.length >0&&
					<div className={"col-md-2"}>
						<h4 className="section-title">Unassigned</h4>
					</div>}*/}
				</div>
				<Framework.Elements.UniversalModal
					size={"xl"}
					id={currentEvent.ticket ? currentEvent.ticket : this.state.ticket ? this.state.ticket.pkey : undefined}
					history={this.props.history}
					object={Objects.ScheduleTicket}
					submitLabel={"Update Ticket"}
					deleteLabel={"Delete Ticket"}
					locations={[""]}
					name={currentEvent.title ? currentEvent.title : this.state.ticket ? this.state.ticket.summary : "Ticket"}
					toggle={this.state.showTicketModal}
					reportClose={this.toggleClose}
					afterSave={this.handleUpdate}
					hasDelete={false}
					hideGoTo={true}
					showModal={this.state.showTicketModal}
					objectProps={{
						toggleModal: this.toggleClose,
						eventID: this.state.currentEvent.id ?? null,
						updateData: this.props.updateData,
						suspendTimeout: this.props.suspendTimeout,
						parent: this
					}}
					additionalButtons={
						<>
							{currentEvent.tickets?.onboard_ticket ? <Button
								color="danger"
								onClick={() => {
									confirmAlert({
										title: 'Confirm Delete',
										message: 'Are you sure you want to delete this onboarding ticket?',
										buttons: [{
											label: 'Yes', onClick: async () => {
												if (this.state.currentEvent.id) {
													let model = new API.BuildClass(Types.Calendar._name, API.RequestType.DELETE);
													this.delete = 'DELETE';
													model.object.pkey = this.state.currentEvent.id;
													try {
														await model.submit(null, this.delete);
														this.props.updateData();
													} catch (error) {
													}
												}
											}
										}, {
											label: 'No', onClick: () => {
											}
										}],
										onClose: () => {
											this.toggleClose()
										}
									});
								}}>
								Delete Onboarding Ticket
							</Button> : <Button
								color="info"
								onClick={async () => {
									//fetch onboarding engineers
									let onboardees = new API.BuildClass(Types.Users._name, API.RequestType.READ);
									onboardees.filter = {fitlerDate: this.state.selectedDay};
									onboardees = await onboardees.submit(null, 'GET_ONBOARDEES')
									if (onboardees) {
										this.setState({modalOnboarding: true, onboardees: onboardees.items})
									}
								}}>
								Create Onboarding Ticket
							</Button>}
						</>
					}
				/>


				<Modal
					isOpen={this.state.showModal}
					toggle={this.toggleClose}
					size={"md"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader toggle={this.toggleClose}>
						{currentEvent.id ? currentEvent.title : "Add Event"}
					</ModalHeader>
					<ModalBody>
						<div className={"row"}>
							<div className={"col-12"}>
								<div className={"form-group"}>
									<TextField
										fullWidth={true}
										size={"small"}
										label={"Title"}
										value={this.state.currentEvent.title}
										onChange={(e) => this.setState({currentEvent: {...this.state.currentEvent, title: e.currentTarget.value}})}
										variant="outlined"
									/>
								</div>
							</div>
							{/*{!currentEvent.allDay && <div className={"col-6"}>*/}
							{/*	<div className={"form-group"}>*/}
							{/*		<TextField*/}
							{/*			fullWidth={true}*/}
							{/*			size={"small"}*/}
							{/*			label={"Ticket ID"}*/}
							{/*			value={this.state.currentEvent.ticket}*/}
							{/*			onChange={(e) => this.setState({currentEvent: {...this.state.currentEvent, ticket: e.currentTarget.value}})}*/}
							{/*			variant="outlined"*/}
							{/*		/>*/}
							{/*	</div>*/}
							{/*</div>}*/}
						</div>
						{!currentEvent.allDay && <div className={"row"}>
							<div className={"col-6"}>
								<div className={"form-group"}>
									<TextField
										fullWidth={true}
										size={"small"}
										label={"Start Time"}
										value={this.state.currentEvent.start ? moment(this.state.currentEvent.start).format('MMMM Do YYYY, h:mm:ss a') : null}
										variant="outlined"
									/>
								</div>
							</div>
							<div className={"col-6"}>
								<div className={"form-group"}>
									<TextField
										fullWidth={true}
										size={"small"}
										label={"End Time"}
										value={this.state.currentEvent.end ? moment(this.state.currentEvent.end).format('MMMM Do YYYY, h:mm:ss a') : null}
										variant="outlined"
									/>
								</div>
							</div>
						</div>}
						<div className={"row"}>
							<div className={"col-12"}>
								<div className={"form-group"}>
									<TextField
										fullWidth={true}
										size={"small"}
										label={"Description"}
										value={this.state.currentEvent.description}
										onChange={(e) => this.setState({
											currentEvent: {
												...this.state.currentEvent,
												description: e.currentTarget.value
											}
										})}
										variant="outlined"
										multiline={true}
										rows={8}
									/>
								</div>
							</div>
							<div className={'col-6'}>
								<FormGroup>
									<FormControlLabel control={<Checkbox
										checked={this.state.currentEvent.block}
										onChange={(e) => {
											this.setState({currentEvent: {...this.state.currentEvent, block: !this.state.currentEvent.block}})
										}}
										color={'primary'}
									/>} label={"Block Availability"}/>
								</FormGroup>
							</div>
							<div className={'col-6'}>
								<FormGroup>
									<FormControlLabel control={<Checkbox
										checked={this.state.currentEvent.actionable}
										onChange={(e) => {
											this.setState({
												currentEvent: {
													...this.state.currentEvent, actionable: !this.state.currentEvent.actionable
												}
											})
										}}
										color={'primary'}
										disabled={this.state.currentEvent.actionable}
									/>} label={"Require Checkbox"}/>
								</FormGroup>
							</div>

							<div className={'col-6'}>
								<FormGroup>
									<FormControlLabel control={<Checkbox
										checked={this.state.currentEvent.mapped}
										onChange={(e) => {
											this.setState({
												currentEvent: {
													...this.state.currentEvent, mapped: !this.state.currentEvent.mapped
												}
											})
										}}
										color={'primary'}
									/>} label={"Add Address"}/>
								</FormGroup>
							</div>
							<div className={'col-6'}>
								<FormGroup>
									<FormControlLabel control={<Checkbox
										checked={this.state.currentEvent.temp_fifth && this.state.currentEvent.temp_fifth === this.state.selectedDay || this.state.currentEvent.temp_fifth === true}
										onChange={(e) => {
											this.setState({
												currentEvent: {
													...this.state.currentEvent,
													temp_fifth: typeof (this.state.currentEvent.temp_fifth) === 'string' ? this.state.currentEvent.temp_fifth === this.state.selectedDay ? false : true : !this.state.currentEvent.temp_fifth
												}
											})
										}}
										color={'primary'}
									/>} label={"Allow 5th Appointment"}/>
								</FormGroup>
							</div>

							<div className={'col-12'}>
								<FormGroup>
									<TextField
										fullWidth={true}
										size={"small"}
										label={"Address"}
										value={this.state.currentEvent.map_address}
										onChange={(e) => this.setState({
											currentEvent: {
												...this.state.currentEvent,
												map_address: e.currentTarget.value
											}
										})}
										variant="outlined"
										disabled={!this.state.currentEvent.mapped}
									/>
								</FormGroup>
							</div>
							{currentEvent.id && <Button data-id="calendar-log"
							                            onClick={this.toggleModalCalendarLog}
							                            size="sm"
							                            color="grey">
								<i className="fa fa-user"/>&nbsp;&nbsp;Created By {this.state.currentEvent.creatorName} on&nbsp;
								{moment(this.state.currentEvent.created).format('MM/DD/YY')}
								&nbsp;at {moment(this.state.currentEvent.created).format('h:mm a')}
							</Button>}
							{currentEvent.id && currentEvent.actioned && <Button data-id="calendar-log"
							                                                     onClick={this.toggleModalCalendarLog}
							                                                     size="sm"
							                                                     color="grey">
								<i className="fa fa-user"/>&nbsp;&nbsp;Checked off as completed
								by {this.state.currentEvent.actioned_by} on&nbsp;
								{moment(this.state.currentEvent.actioned_on).format('MM/DD/YY')}
								&nbsp;at {moment(this.state.currentEvent.actioned_on).format('h:mm a')}
							</Button>}
							<Framework.Elements.UniversalModal
								name={"Change Logs"}
								parent={currentEvent.id}
								history={this.props.history}
								object={Collections.CalendarLogModal}
								toggle={this.state.modalCalendarLog}
								reportClose={() => this.toggleCloseCalendarLog()}
								hideGoTo={true}
								hasSubmit={false}
								size={'xl'}
							/>
						</div>
					</ModalBody>
					<ModalFooter>
						{this.state.currentEvent.map_address &&
							<a href={"https://www.google.com/maps/dir/" + this.state.currentEvent.map_address.replaceAll("#", "%23")}
							   target={'_blank'}>
								<Button color="primary">
									View on Google Maps</Button>
							</a>}
						{(this.state.ticket !== currentEvent.ticket && currentEvent.allDay !== true) &&
							<Link to={"/tickets/" + this.state.currentEvent.ticket}>
								<Button color="primary">
									Go to Ticket</Button>
							</Link>}
						<Button color="primary" onClick={this.handleSave}>Save</Button>
						{currentEvent.id ? <Button color="danger" onClick={this.handleDelete}>Delete</Button> :
							<Button color="secondary" onClick={this.toggleClose}>Close</Button>}
					</ModalFooter>
				</Modal>

				<Modal
					isOpen={this.state.show_hd_modal}
					toggle={this.toggleClose}
					size={"xl"}
					backdrop={true}
					style={{opacity: 1, maxWidth: window.innerWidth * .9}}
				>
					<ModalBody>
						<div className={'form-group'}>
							{this.state.field_engineer ?
								<EngineerHDCard history={this.props.history} currentDay={moment(this.state.selectedDay).format("YYYY-MM-DD")}
								                engineer={this.state.field_engineer} refreshData={async () => {
									await this.getHelpdesks(this.state.field_engineer?.pkey)
								}}/>
								: <p>No helpdesk data available for this field engineer.</p>}
						</div>
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={this.toggleClose}>Close</Button>
					</ModalFooter>
				</Modal>

			<Modal
				isOpen={this.state.modalOnboarding}
				toggle={this.toggleClose}
				size={"md"}
				backdrop={true}
				style={{opacity: 1}}
			>
				<ModalHeader toggle={this.toggleClose}>
					Create Onboarding Ticket
				</ModalHeader>
				<ModalBody>
					<div className={'form-group'}>
						<b>If you do not see the FE you want here, ensure that the date of this ticket is before or equal to the First Day in Field in their user profile.</b>
						<Select
							key={this.state.onboardees}
							placeholder={"Onboard FE Select"}
							value={this.state.onboardee ? {value: this.state.onboardee.pkey, label:  (this.state.onboardee.name_first + ' ' + this.state.onboardee.name_last)} : null}
							onChange={async (value) => {
								await this.setState({onboardee: this.state.onboardees.find((user) => user.pkey === value.value)})
							}}
							options={this.state.onboardees?.map(user => {
								return (
									{value: user.pkey, label: (user.name_first + ' ' + user.name_last)}
								)
							})}
							styles={{
								singleValue: (provided, state) => ({
									...provided,
									display: 'flex',
									alignItems: 'center'
								}),
								option: (provided, state) => ({
									...provided,
									display: 'flex',
									alignItems: 'center'
								})
							}}
						/>

					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="primary" disabled={this.state.onboardee === null} onClick={async () => {
						let model = new API.BuildClass(Types.Tickets._name, API.RequestType.UPDATE);
						model.object.pkey = this.state.currentEvent.ticket;
						model.object.onboardee = this.state.onboardee.pkey;

						let data = null;
						try {
							await model.submit(null, 'POST_TICKET_ONBOARDING');
						} catch (error) {
						}
						if (typeof(this.props.updateData) === 'function') {
							this.props.updateData();
						}
						this.toggleClose();
					}}>Create</Button>
					<Button color="secondary" onClick={this.toggleClose}>Close</Button>
				</ModalFooter>
			</Modal>
			</div>);
	}
}

